
















































import {
  defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import { login } from '@/api/index';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const Login = defineComponent({
  components: {
    CommonModalWithPreset,
  },
  setup() {
    const { router } = useRouter();
    const modal = ref(null);

    const loginFormInput = reactive({
      email: '',
      password: '',
    });

    const loginHandler = async () => {
      const result = await login(
        loginFormInput.email,
        loginFormInput.password,
      );
      if (result === true) {
        router.push({
          name: 'Dashboard',
        });
      } else {
        (modal.value as any).compose({ action: 'ปิดหน้าต่าง' });
      }
    };

    return {
      loginHandler,
      modal,
      loginFormInput,
      buildNote: (window as any).BUILD_NOTE,
    };
  },
});

export default Login;
